import PoolsApi from '../api/pools'
import { addInfoNotification, addErrorNotification } from './notifications'
import { HIDE_MODAL } from './modal'
import { loadPoolAsync, loadPoolSummaryAsync } from './poolDetails'
import { BACKEND_PROPAGATION_DELAY_MS } from '../constants/delays'

export const MANUALLY_CHANGE_POOL_STATUS = 'MANUALLY_CHANGE_POOL_STATUS'

export const manuallyChangePoolStatus = (poolId, isManuallyOfflineNow) => {
  return dispatch => {
    dispatch({
      type: HIDE_MODAL
    })

    let func = isManuallyOfflineNow ? PoolsApi.ManuallyOnlinePool : PoolsApi.ManuallyOfflinePool
    func(poolId)
      .then((response) => {
        if (response.ok) {
          dispatch(addInfoNotification(`Pool was ${isManuallyOfflineNow ? 'onlined' : 'offlined'}`))
          // Delay re-fetching pool data to allow the backend to propagate
          // the status change (e.g. updated offlineEvents) before we read it back
          setTimeout(() => {
            dispatch(loadPoolSummaryAsync({ id: poolId }))
            dispatch(loadPoolAsync({ id: poolId }))
          }, BACKEND_PROPAGATION_DELAY_MS)
        } else {
          return response.text()
            .then(errorMessage => {
              throw new Error(errorMessage)
            })
        }
      })
      .catch(error => {
        dispatch(addErrorNotification('Error during pool status change', error.message))
        console.log('Catch fetch error: ', error)
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/manuallyChangePoolStatus.js